import * as _ from "lodash";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Comment } from "app/shared/types/comments";
import { GatewayBase, JsonDates } from "../bases";

export interface CreateComment {
    replyingToCommentId?: number;
    message: string;
    organizationId: number;
}

@Injectable({ providedIn: "root" })
export class CommentsGateway extends GatewayBase {
    constructor(private _httpClient: HttpClient) {
        super();
    }

    getComments(commentHandleId: number): Observable<Comment[]> {
        return this._httpClient
            .get<JsonDates<Comment[]>>(`/api/v1.0/comments`, {
                params: { handleId: commentHandleId.toString() }
            })
            .pipe(map(comments => this._remapComments(comments)));
    }

    postComment(args: CreateComment): Observable<Comment> {
        return this._httpClient
            .post<JsonDates<Comment>>(`/api/v1.0/comments`, args)
            .pipe(map(comment => this._remapComment(comment)));
    }

    editComment(commentId: number, message: string, isResolved: boolean): Observable<void> {
        return this._httpClient.put<void>(`/api/v1.0/comments/${commentId}`, {
            isResolved,
            message
        });
    }

    deleteComment(commentId: number): Observable<void> {
        return this._httpClient.delete<void>(`/api/v1.0/comments/${commentId}`);
    }

    private _remapComments(comments: JsonDates<Comment[]>): Comment[] {
        return _.map(comments, comment => this._remapComment(comment));
    }

    private _remapComment(comment: JsonDates<Comment> | null): Comment | null {
        if (!comment) return null;
        return {
            ...comment,
            created: this._parseDateTime(comment.created),
            edited: this._parseDateTime(comment.edited),
            comments: this._remapComments(comment.comments)
        };
    }
}
